export default __webpack_public_path__ + "static/circle-dollar-to-slot-light.png";